/**
 * Reconcilia o transcript do banco com o rascunho local ao reabrir uma sessao.
 * O mais longo vence: como a captura so acrescenta texto, comprimento e um proxy
 * confiavel de "mais recente" e nao depende de relogios sincronizados.
 */
export const chooseTranscriptSource = (
  remote: string,
  local: string | null,
): { transcript: string; needsUpload: boolean } => {
  const remoteText = remote ?? "";
  const localText = local ?? "";

  if (localText.length > remoteText.length) {
    return { transcript: localText, needsUpload: true };
  }

  return { transcript: remoteText, needsUpload: false };
};
